import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import moment from "moment";
import "./SupAdmBiddetails.css";
import { NavLink, Link } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";
import Superside from "../superadmin/Superside";
import { SuperadminContext } from "../context/superadmincontext";
import {useNavigate,useLocation} from "react-router-dom"
import Cookies from 'js-cookie';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import userimage from "./images/userimage.png"
 
 
const SupAdmBiddetails = () => {
  const usernamedashboard = localStorage.getItem("username");
 
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const { superadminname } = useContext(SuperadminContext);
  const [user, setuser] = useState({});
  const [errorMessage, setErrorMessage] = useState(""); // New state for error message
 
 
 
  const navigate = useNavigate();
  const location = useLocation();
  const [role, setRole] = useState("");
  const [username, setUsername] = useState("");
 
  useEffect(() => {
      const token = Cookies.get('token');
      const { state } = location;
 
      if (token) {
         
          if (location.pathname !== '/superadminbidingdetails') {
              navigate('/superadminbidingdetails');
          }
          return;
      }
 
      if ( !state || !state.username || !state.role) {
        if (location.pathname !== '/superadmin') {
          navigate('/');
        }
        return;
      }
     
          setUsername(state.username);
          setRole(state.role);
          console.log(state.username, state.role);
         
    }, [location, navigate]);
 
 
 
  const loadData = async () => {
    const response = await axios.get("http://localhost:5001/chit/allbidingdata/get/receiption");
    setData(response.data);
  };
  useEffect(() => {
    loadData();
  }, []);
 
  
 
 
  const dltbid = async (bidingId) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this item?");
    if (isConfirmed) {
      try {
        const res = await axios.delete(
          `http://localhost:5001/api/delete/bid/${bidingId}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (res.data.status === 201) {
          toast.success("Successfully deleted!");
          loadData();
          // navigate("/moreinfo");
        }
      } catch (error) {
        if (error.response && error.response.data.message) {
          toast.error(error.response.data.message);
        } else {
          toast.error("An unexpected error occurred.");
        }
      }
    }
  };
 
  useEffect(() => {
    const fetchnameData = async () => {
      try {
        const response = await axios.get(
          `http://localhost:5001/api/getmemberdetails/afterlogin/${usernamedashboard}`
        );
        setuser({ ...response.data[0] });
      } catch (error) {
        console.error("Error fetching assessment data", error);
      }
    };
    fetchnameData();
  }, [usernamedashboard]);
 
 
  return (
    <div style={{ display: "flex", overflow:"hidden" }}>
      <div>
        <Superside />
      </div>
      <div className="mm" style={{ overflow:"hidden" }}>
      <div className="hj">
      <div>
        <div className="Super-Member-courses-head">
          <div className="super-dash-heading">
            <h2>Biding Details</h2>
          </div>

          <div className="Super-Member-profile-set">
            <div>
              <img
              src={user.uploadPhoto? `http://localhost:5001/uploads/${user.uploadPhoto}` : userimage}
                // src={`http://localhost:5001/uploads/${user.uploadPhoto}`}
                alt=""
                style={{
                  height: "50px",
                  borderRadius: "30px",
                  width: "50px",
                }}
                className="images"
              ></img>
            </div>
            <div>
              <p style={{ margin: "0px" }}>{user.UserName}</p>
              <p style={{ margin: "0px" }}>({user.role})</p>
            </div>
          </div>
        </div>
      </div>
       
        <hr />
 
        <div className="super-Bidde-searchContainer">
          <input
            type="search"
            placeholder="Search by Name"
            className="Bidde-search"
            onChange={(e) => setSearch(e.target.value)}
            value={search}
          />
        </div>
 
        <div className="">
          <div className="super-Bidde-table-auction">
            <table className="super-Bidde-table-style">
              <thead>
                <tr>
                  <th className="tahe" style={{ textAlign: "center" }}>No.</th>
                  <th className="tahe" style={{ textAlign: "center" }}>groupId</th>
                  <th className="tahe" style={{ textAlign: "center" }}>chit Amount</th>
                  <th className="tahe" style={{ textAlign: "center" }}>No.of users</th>
                  <th className="tahe" style={{ textAlign: "center" }}>installment Number</th>
                  <th className="tahe" style={{ textAlign: "center" }}>commission</th>
                  <th className="tahe" style={{ textAlign: "center" }}>bid Amount</th>
                  <th className="tahe" style={{ textAlign: "center" }}>bid Winner</th>
                  <th className="tahe" style={{ textAlign: "center" }}>
                    collecting from subcriber
                  </th>
                  <th className="tahe" style={{ textAlign: "center" }}>pay to Winner</th>
                  <th className="tahe" style={{ textAlign: "center" }}>AuctionId</th>
                  <th className="tahe" style={{ textAlign: "center" }}>date</th>
                  <th className="tahe" style={{ textAlign: "center" }}>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {data
                  .filter(
                    (data) =>
                      data.bid_winner
                        .toLowerCase()
                        .includes(search.toLowerCase()) ||
                      //data.id_group === parseInt(search)
                      data.id_group.toString() === search.trim() ||
                      data.id_auction === parseInt(search)
                  )
                  .map((item, index) => {
                    return (
                      <tr>
                        <td>{index + 1}</td>
                        <td>{item.id_group}</td>
                        <td>{item.amount_chit}</td>
                        <td>{item.user_num}</td>
                        <td>{item.install_numb}</td>
                        <td>{item.comision}</td>
 
                        <td>{item.amount_bid}</td>
 
                        <td>{item.bid_winner}</td>
 
                        <td>{item.payoutsub}</td>
                        <td>{item.payinsub}</td>
                        <td>{item.id_auction}</td>
 
                        <td>{moment(item.date).format("DD-MM-YYYY")}</td>
                        <td>
                          <button
                            onClick={() => dltbid(item.bidingId)}
                            className="ch" style={{ marginLeft:"10px" }}
                          >
                            Delete
                          </button>
                          {/* <Link to={`/Payout/${item.bidingId}`}>
                            <button className="ch">Payout</button>
                          </Link> */}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        </div>
        {errorMessage && (
          <div className="popup">;
            <div className="popup-inner">
              <h3>Warning!</h3>
              <p>{errorMessage}</p>
              <button className="popup-close" onClick={() => setErrorMessage("")}>Close</button>
           </div>
          </div>
        )}
      </div>
      </div>
     <ToastContainer/>
    </div>

  );
};
 
export default SupAdmBiddetails;